<template>
  <div class="card-item">
    <div class="text-grey lighten-2 flex-row align-center">
      {{ props.title }}
      <template v-if="titleButton">
        <v-spacer />
        <app-button v-bind="titleButton" />
      </template>
    </div>
    <router-link :to="props.to">
      {{ props.text }}
    </router-link>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { type: String, required: true },
  text: { type: String, required: true },
  to: { type: Object, required: true },
  titleButton: { type: Object, default: null }
});
</script>
